import React from 'react';
import PropTypes from 'prop-types';
import { withPrefix } from 'gatsby';
import { Header } from '@massds/mayflower-react';
import SiteLogo from '../SiteLogo';

import './index.scss';

const BudgetHeader = (props) => {
  const {
    siteName, title, subTitle, theme, mainNav
  } = props;
  const siteLogoProps = {
    url: {
      domain: withPrefix('/')
    },
    siteName,
    title,
    subTitle,
    theme
  };

  const headerSearchProps = {
    id: 'header-search',
    label: 'Search terms',
    placeholder: `Search ${siteName}`,
    buttonSearch: {
      'aria-label': '',
      usage: 'secondary'
    }
  };

  const headerProps = {
    ...props,
    mainNav: mainNav ? {
      ...mainNav
    } : '',
    hideBackTo: true,
    siteLogo: () => <SiteLogo {...siteLogoProps} />,
    headerSearch: headerSearchProps,
    searchRedirect: {
      baseUrl: withPrefix('/search'),
      searchTermParam: 'query',
      queryParams: { page: 1 }
    }
  };
  return<Header {...headerProps} />;
};

BudgetHeader.propTypes = {
  /** An `items` array of utility nav items render in the top blue utility bar.
   Same shape as mayflower-react UtilityNav proptypes. */
  utilityNav: PropTypes.object,
  /** An `mainNav` array of main nav items render in the top blue utility bar.
   Same shape as mayflower-react MainNav proptypes. */
  mainNav: PropTypes.object,
  /** Whether to hide the searchbox in the header.
    Default to false in Layout component for govbudget, capital and summary sites, expect for the search results pages.
    Default to true in coming-soon site.
  */
  hideHeaderSearch: PropTypes.bool,
  // The site name is rendered next to the site logo
  siteName: PropTypes.string,
  // The title is rendered as the link title of the SiteLogo, displayed when mouse over the SiteLogo
  title: PropTypes.string,
  // The site subTitle is rendered below the site name with a colored background
  subTitle: PropTypes.string,
  // The theme controls the color used in the SiteLogo
  theme: PropTypes.oneOf(['govbudget', 'capital', 'summary', ''])
};

export default BudgetHeader;
